import type { Filter, MeasurementUnit } from '@cvent/venue-search-shared/types';
import { Locale, LOCALE_HEADER } from '@/i18n';
import type { BrandAndChainResponse } from '@/app/api/venue-autocomplete/route';
import { VIEW } from '@/constants/queryConstants';
import { MAP_SIZE, type MapView } from '@/constants/mapConstants';

/**
 * Call Venue Auto Complete endpoint
 */
export default async function getVenueAutoComplete(
  searchTerm: string,
  measurementUnit: MeasurementUnit,
  geo: string | undefined,
  locale: Locale,
  filter: Filter,
  mapView: MapView
): Promise<BrandAndChainResponse | null> {
  const result = await fetch('/venues/api/venue-autocomplete', {
    method: 'POST',
    body: JSON.stringify({
      filter,
      measurementUnit,
      searchTerm,
      geo,
      locale,
      view: mapView === MAP_SIZE.FULL ? VIEW.MAP : VIEW.LIST
    }),
    headers: { [LOCALE_HEADER]: locale }
  });
  if (result.ok) {
    return result.json();
  }
  return null;
}
